
export type GetTweetById200MediaItemDimensions = {
  height?: number;
  width?: number;
};
